import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'antd'
import { ArrowLeftOutlined } from '@ant-design/icons'
import CustomerDetailBody from './CustomerDetailBody'

// Routed, full-page customer detail (opened in a new tab from the list). Renders the same shared
// body the quick-view modal uses, so both views are always identical.
const CustomerDetail = props => {
  const { id } = props.match.params
  return (
    <div className="container">
      <div className="card mb-5rem">
        <div className="card-body">
          <Button
            type="link"
            icon={<ArrowLeftOutlined />}
            style={{ paddingLeft: 0, marginBottom: 8 }}
            onClick={() => props.history.push('/custom-duties/customers')}
          >
            Back to customers
          </Button>
          <CustomerDetailBody id={id} />
        </div>
      </div>
    </div>
  )
}

CustomerDetail.propTypes = {
  match: PropTypes.object,
  history: PropTypes.object
}

export default CustomerDetail
